import LoadingLine from '../utils/_loadingLine'

const pageLoading = document.querySelector('.pageLoading')
if (pageLoading) {
  const canvas = document.querySelector('.pageLoading__canvas')
  const loading = new LoadingLine(canvas)
  loading.draw(0)

  const container = document.querySelector('.pageLoading__container')

  const pageHeadImgs = document.querySelectorAll('.pageHead img')
  const maxImgCount = pageHeadImgs.length > 0 ? pageHeadImgs.length : 1
  let loadedImgCount = 0

  const stateImg = {
    progress: 0,
    speed: 0.05,
    isFinished: false,
  }

  const stateLine = {
    progress: 0,
    speed: 0.075,
    isFinished: false,
  }

  /**
   * 画像読み込みカウント
   */
  const onImgLoaded = () => {
    loadedImgCount++
  }

  /**
   * 画像読み込みチェック
   */
  if (pageHeadImgs.length > 0) {
    pageHeadImgs.forEach((img) => {
      if (img.complete && img.naturalHeight > 0) {
        onImgLoaded()
        return
      }
      img.addEventListener('load', onImgLoaded, { once: true })
    })
  } else {
    loadedImgCount = 1
  }

  /**
   * 更新処理
   */
  const update = () => {
    if (!stateImg.isFinished) {
      if (stateImg.progress < loadedImgCount) {
        stateImg.progress = (stateImg.progress + stateImg.speed).clamp(0, loadedImgCount)
      }

      const progress = stateImg.progress / maxImgCount
      stateImg.isFinished = progress == 1

      container.style.clipPath = `inset(0 ${100 * (1 - progress)}% 0 0)`
      loading.draw(0)

      requestAnimationFrame(update)
    } else if (!stateLine.isFinished) {
      stateLine.progress = (stateLine.progress + stateLine.speed).clamp(0, 3)

      const ratioOpen = stateLine.progress.clamp(0, 1.5)
      const ratioFade = ((stateLine.progress - 1.5) / 1.5).clamp(0, 1)

      loading.draw(ratioOpen)
      pageLoading.style.opacity = 1 - ratioFade

      stateLine.isFinished = ratioOpen == 1.5 && ratioFade == 1

      if (!stateLine.isFinished) {
        requestAnimationFrame(update)
      } else {
        pageLoading.remove()
      }
    }
  }
  update()
}
